import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../types';
import { ErrorAlertProps } from './props';
import { ErrorAlertRenderer } from './ErrorAlertRenderer';
import { errorAlertMessage } from './errorAlertMessage';

const ErrorAlertComponent: React.FC<ErrorAlertProps> = ({ error, customMessage }) => {
  const intl = useIntl();
  const message = useMemo(() => errorAlertMessage(intl, error, customMessage), [customMessage, error, intl]);

  return <ErrorAlertRenderer message={message} />;
};

export const ErrorAlert = TypedMemo(ErrorAlertComponent);
